export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_LICENSE = 'UPDATE_LICENSE';
export const UPDATE_PROFILE_SETTINGS = 'UPDATE_PROFILE_SETTINGS';
export const DELETE_PROFILE_SETTINGS = 'DELETE_PROFILE_SETTINGS';

export const initialAuthState = {
    isLoggedIn: false,
    isInitialized: false,
    keepMeLoggedIn: false,
    serviceToken: null,
    refreshToken: null,
    user: {},
    profileSettings: [],
    license: {}
};

const authReducer = (state = initialAuthState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user, profileSettings } = action?.payload || {};

            return { ...state, user: user || {}, profileSettings: profileSettings || [], license: {} };
        }
        case LOGIN: {
            const { serviceToken, refreshToken, keepMeLoggedIn, user, profileSettings, license } = action?.payload || {};

            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                keepMeLoggedIn: Boolean(keepMeLoggedIn),
                serviceToken: serviceToken || null,
                refreshToken: refreshToken || null,
                user: user || {},
                profileSettings: profileSettings || [],
                license: license || {}
            };
        }
        case LOGOUT: {
            return { ...initialAuthState, isInitialized: true };
        }
        case UPDATE_USER: {
            const { user } = action?.payload || {};

            return { ...state, user: user || {} };
        }
        case UPDATE_LICENSE: {
            const { license } = action?.payload || {};

            return { ...state, license: license || {} };
        }
        case UPDATE_PROFILE_SETTINGS: {
            const { profileSettings } = action?.payload || {};

            return { ...state, profileSettings: profileSettings || [] };
        }
        case DELETE_PROFILE_SETTINGS: {
            const { settingsIds } = action?.payload || {};

            return { ...state, profileSettings: state.profileSettings?.filter((profSett) => !settingsIds?.includes(profSett?.id)) || [] };
        }
        default: {
            return state;
        }
    }
};

export default authReducer;
